import type { TFurniture } from "types/elevationReferences.type"
import { isCountertop, isModelConfirmed, isOtherFurniture } from "./furnitureModel.helpers"
import style from "./FurnitureModelLabel.module.scss"

const { modelNumber, modelNotConfirmed, countertop } = style

type Props = { item: TFurniture }

export const FurnitureModelLabel = ({ item }: Props) => {
	if (isOtherFurniture(item)) {
		const name = item.fixed_price_config?.name?.trim()
		if (name) return <span className={modelNumber}>{name}</span>
		return <span className={modelNotConfirmed}>Other</span>
	}

	if (isModelConfirmed(item)) {
		return <span className={modelNumber}>{item.selected_model_number!.model_number}</span>
	}

	if (isCountertop(item)) {
		return <span className={countertop}>Countertop</span>
	}

	return <span className={modelNotConfirmed}>Model not confirmed</span>
}
